var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "071xucnxda"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.662745 0 0 0 0 0.670588 0 0 0 0 0.674510 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#071xucnxda)",
    transform: "translate(7 6) translate(2.353 2.353)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E36510",
    d: "M17.647 31.765c-7.8 0-14.118-6.318-14.118-14.118 0-7.8 6.318-14.117 14.118-14.117 7.8 0 14.118 6.317 14.118 14.117 0 7.8-6.318 14.118-14.118 14.118M17.63 0C7.89 0 0 7.906 0 17.647s7.888 17.647 17.63 17.647c9.758 0 17.664-7.906 17.664-17.647C35.294 7.907 27.388 0 17.63 0"
  })), /*#__PURE__*/React.createElement("path", {
    filter: "url(#071xucnxda)",
    fill: "#E36510",
    d: "M18.529 8.824L15.882 8.824 15.882 19.412 25.147 24.969 26.471 22.8 18.529 18.088z",
    transform: "translate(7 6) translate(2.353 2.353)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.816c02f8ce46ca0467015d121e23a925.svg";
export { ForwardRef as ReactComponent };